"use client";

import { FC } from "react";
import TextTitle from "apps/website/components/base/Text/TextTitle/TextTitle";
import type {
  TextTitleVariantsProps,
} from "apps/website/components/base/Text/TextTitle/styles";
import cx from "apps/website/utils/misc/cx";

export interface TitleSectionProps {
  title: string | undefined;
  getTitle: () => string;
  bgClassName?: string;
  titleSize?: TextTitleVariantsProps["size"];
}

export const TitleSection: FC<TitleSectionProps> = ({
  title,
  getTitle,
  bgClassName = "bg-white",
  titleSize = 3,
}) => {
  if (!title) {
    return null;
  }

  return (
    <div className={cx(bgClassName, "pt-2 pb-2 lg:pb-3")}>
      <TextTitle size={titleSize} align="center" className="px-4">
        { getTitle() }
      </TextTitle>
    </div>
  );
};
